import React, {useState} from "react";
import {View, Text, Image, TouchableOpacity , StyleSheet} from "react-native";
import AntDesign from "@expo/vector-icons/AntDesign";
import {RFValue} from "react-native-responsive-fontsize";

import Toast from "./Toast";
import toast from "./Toast";


const According = ({data,navigation})=>{

    let [child, setChild] = useState(data);




    const [show, setShow] = useState(false);
    return (
        <View  style={styles.according}>
            <TouchableOpacity onPress={()=>setShow(!show)} style={styles.header}>
                <Text style={styles.accordingTitle}>
                    {child.name}
                </Text>
                {show ?
                    <AntDesign name="up" size={RFValue(20)} color="black" />
                    :
                    <AntDesign name="down" size={RFValue(20)} color="black" />
                }

            </TouchableOpacity>

            {show &&
                <View style={styles.childs}>
                    {child.has_lessons &&  child.lessons.map((item,index) =>
                        <View key={index}>

                            {item.type === 'O' &&
                                <TouchableOpacity onPress={()=>navigation.navigate('Lesson',{lesson_id : item.lesson_id})} style={styles.item}>
                                    <View style={styles.itemrow}>
                                        <Text style={styles.itemtitle}>
                                            {item.title}
                                        </Text>
                                    </View>
                                    {item.number != 0 &&
                                        <Text style={styles.percent2}>%{item.number}</Text>
                                    }
                                </TouchableOpacity>
                            }
                            {item.type === 'L' &&
                                <TouchableOpacity onPress={()=>toast('لطفاً ابتدا دوره را تهیه کرده و سپس دروس را به ترتیب مشاهده کنید.')} style={styles.item}>
                                    <View style={styles.itemrow}>
                                        <AntDesign name="lock" style={{marginLeft : '8'}} size={RFValue(20)} color="#FD0000" />
                                        <Text style={styles.itemtitle}>
                                            {item.title}
                                        </Text>
                                    </View>
                                </TouchableOpacity>
                            }
                            {item.type === 'S' &&
                                <TouchableOpacity onPress={()=>navigation.navigate('Lesson',{lesson_id : item.lesson_id})} style={styles.item}>
                                    <View style={styles.itemrow}>
                                        <AntDesign name="checkcircleo" style={{marginLeft : '8'}} size={RFValue(20)} color="#33B300" />
                                        <Text style={styles.itemtitle}>
                                            {item.title}
                                        </Text>
                                    </View>
                                    <Text style={styles.percent}>%{item.number}</Text>
                                </TouchableOpacity>
                            }
                        </View>
                    )}
                </View>
            }
        </View>
    );
}
const styles = StyleSheet.create({
    percent : {
        fontFamily : "ykb",
        fontSize : RFValue(14),
        color : '#33B300',
    },
    percent2 : {
        fontFamily : "ykb",
        fontSize : RFValue(14),
        color : '#FD0000',
    },

    itemrow : {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
    },

    itemtitle:{
        fontFamily : "yk",
        fontSize : RFValue(14),
        color : '#0D1134',
    },

    item : {
        paddingHorizontal : RFValue(10),
        paddingVertical : RFValue(13),
        marginTop : RFValue(10),
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        width: "100%",
        backgroundColor : 'white',
        borderRadius : RFValue(8),
    },

    childs : {
    },

    accordingTitle : {
        fontFamily : "ykb",
        fontSize : RFValue(15),
        color : '#0D1134',
    },

    header : {
       paddingHorizontal : RFValue(10),
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        width: "100%",
        backgroundColor : 'white',
        borderRadius : RFValue(8),
        paddingVertical : RFValue(23),
    },

    according: {
       display : 'block',
        marginTop : RFValue(10),
    }
    ,

});
export default According;